import { JsonConverter, JsonCustomConvert, JsonObject } from "json2typescript";

@JsonConverter
export class LongitudinalLossConverter implements JsonCustomConvert<LongitudinalLoss> {
  serialize() { }
  deserialize(data: any): LongitudinalLoss {
    const loss = new LongitudinalLoss();
    loss.freq24 = Number(data?.freq24 ?? data?.freq_24 ?? 0);
    loss.freq5 = Number(data?.freq5 ?? data?.freq_5 ?? 0);
    loss.freq6 = Number(data?.freq6 ?? data?.freq_6 ?? 0);
    return loss;
  }
}


@JsonObject("LongitudinalLoss")
export class LongitudinalLoss {
    freq24: number = 0;
    freq5: number = 0;
    freq6: number = 0;
}
